import {
    CHANNELS_PARTNER_TYPES,
    BCP,
    BCPNEGOCIOS,
    BCPPYME,
    CALL_BCPPYME,
} from "../constants/channels";

export const toChannelsPath = (
    path: string,
    channel: string,
    partnerType: string
) => {
    if (partnerType === CHANNELS_PARTNER_TYPES.BUSINESS) {
        return `/empresas/${channel}${path}`;
    } else if (partnerType === CHANNELS_PARTNER_TYPES.CUSTOMERS) {
        return `/${channel}${path}`;
    }
    return path;
};
export const normalizePath = (
    path: string,
    channel: string,
    partnerType: string
) => {
    if (partnerType === CHANNELS_PARTNER_TYPES.BUSINESS) {
        const normalizedPath = path.replace(`/empresas/${channel}`, "");
        return normalizedPath.length ? normalizedPath : "/";
    } else if (partnerType === CHANNELS_PARTNER_TYPES.CUSTOMERS) {
        const normalizedPath = path.replace(`/${channel}`, "");
        return normalizedPath.length ? normalizedPath : "/";
    }
    return path;
};

export const isChannelBcp = (channel: string) =>
    [BCP, BCPNEGOCIOS, BCPPYME, CALL_BCPPYME].includes(channel);
